import mCategoryCard1 from './CategoryCard1.vue'
import mCategoryCard203 from './CategoryCard203.vue'
import mCategoryCard309 from './CategoryCard309.vue'
import mCategoryCard310 from './CategoryCard310.vue'
import mCategoryCard802 from './CategoryCard802.vue'
import mCategoryCard900 from './CategoryCard900.vue'
import mCategoryCard1_1 from './CategoryCard1_1.vue'
import mCategoryCard313 from './CategoryCard313.vue'
import mCategoryCard315 from './CategoryCard315.vue'

export const Cards = {
    mCategoryCard1,
    mCategoryCard203,
    mCategoryCard309,
    mCategoryCard310,
    mCategoryCard802,
    mCategoryCard900,
    mCategoryCard1_1,
    mCategoryCard313,
    mCategoryCard315,
}